export const TIMEZONE_OPTIONS = [
    { label: "Eastern Time", value: "US/Eastern" },
    { label: "Central Time", value: "US/Central" },
    { label: "Mountain Time", value: "US/Mountain" },
    { label: "Pacific Time", value: "US/Pacific" },
    { label: "Alaska Time", value: "US/Alaska" },
    { label: "Hawaii Time", value: "US/Hawaii" },
] as const;

export const VALID_TIMEZONES: string[] = TIMEZONE_OPTIONS.map((tz) => tz.value);

export const DEFAULT_TIMEZONE = "US/Eastern";

/** Validate a timezone string, returning DEFAULT_TIMEZONE if invalid or null. */
export function validateTimezone(tz: string | null | undefined): string {
    return tz && VALID_TIMEZONES.includes(tz) ? tz : DEFAULT_TIMEZONE;
}

/** "Eastern Time" for "US/Eastern"; the zone id itself for anything else. */
export function timeZoneLabel(timeZone: string): string {
    return TIMEZONE_OPTIONS.find((o) => o.value === timeZone)?.label ?? timeZone;
}

/**
 * PRTL-1471 (Phil, Oct 7 2026): every Compass Call series is anchored to the
 * Compass team's clock — US/Eastern — whatever zone its attendees are in.
 * `Meeting.timeZone` and the recurrence engine's `timeZone` parameter stay so
 * this can change later; admin always writes this value today.
 */
export const COMPASS_CALL_TIME_ZONE = "US/Eastern";
